import { Format } from './PrintService';
import ReportsPrintService, { ICfg } from './ReportsPrintService';

/**
 *
 */
export default class EpkReportsPrintService extends ReportsPrintService {
  constructor(cfg: Omit<ICfg, 'ns'>) {
    super({ ...cfg, ns: 'epk-reports' });
  }

  fileNameNew(format: Format) {
    return `svod_${this.pointCode}.${format}`;
  }
}
